import { FiltroEmpresasTraslado, RespuestaEmpresasTraslado, GestionTraslado } from "../modelo/GestionEmpresasModelo";

export const CONSULTAR_EMPRESAS_TRASLADO = "CONSULTAR_EMPRESAS_TRASLADO";
export const DESCARGAR_XLS_EMPRESAS_TRASLADO = "DESCARGAR_XLS_EMPRESAS_TRASLADO";
export const EMPRESAS_TRASLADO_CONSULTADOS = "EMPRESAS_TRASLADO_CONSULTADOS";
export const ERROR_CONSULTANDO_EMPRESAS_TRASLADO = "ERROR_CONSULTANDO_EMPRESAS_TRASLADO";
export const EXITO_DESCARGAR_EMPRESAS_TRASLADO_XLS = "EXITO_DESCARGAR_EMPRESAS_TRASLADO_XLS";
export const ERROR_DESCARGAR_EMPRESAS_TRASLADO_XLS = "ERROR_DESCARGAR_RESPUESTAS_XLS";
export const GESTIONAR_EMPRESAS_TRASLADO = "GESTIONAR_EMPRESAS_TRASLADO";
export const GESTION_EMPRESAS_TRASLADO_EXITO = "GESTION_EMPRESAS_TRASLADO_EXITO";
export const GESTION_EMPRESAS_TRASLADO_ERROR = "GESTION_EMPRESAS_TRASLADO_ERROR";
export const LIMPIAR_MENSAJES_TRASLADO_EMPRESA = "LIMPIAR_MENSAJES_TRASLADO_EMPRESA";

export const consultarEmpresasTraslado = (filtro: FiltroEmpresasTraslado) => ({ type: CONSULTAR_EMPRESAS_TRASLADO, filtro});
export const descargarXLSEmpresasTraslado = (filtro: FiltroEmpresasTraslado) => ({ type: DESCARGAR_XLS_EMPRESAS_TRASLADO, filtro});
export const empresasTrasladoConsultados = (datosRespuesta: Array<RespuestaEmpresasTraslado>, paginas: number, totalDatos: number) => ({ 
    type: EMPRESAS_TRASLADO_CONSULTADOS, datosRespuesta, paginas, totalDatos });
export const errorConsultandoEmpresasTraslado = () => ({ type: ERROR_CONSULTANDO_EMPRESAS_TRASLADO });
export const exitoDescargarEmpresasTrasladoXLS = () => ({ type: EXITO_DESCARGAR_EMPRESAS_TRASLADO_XLS});
export const errorDescargarEmpresasTrasladoXLS = () => ({ type: ERROR_DESCARGAR_EMPRESAS_TRASLADO_XLS});
export const gestionarEmpresasTraslado = (solicitud: GestionTraslado) => ({ type: GESTIONAR_EMPRESAS_TRASLADO, solicitud});
export const gestionEmpresasTrasladoExito = () => ({ type: GESTION_EMPRESAS_TRASLADO_EXITO});
export const gestionEmpresasTrasladoError = (mensaje: string) => ({ type: GESTION_EMPRESAS_TRASLADO_ERROR, mensaje});
export const limpiarMensajesTrasladoEmpresa = () => ({type: LIMPIAR_MENSAJES_TRASLADO_EMPRESA});



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/gestion_empresas_trasladables/modulos/gestionEmpresaTrasladoActions.ts